<template>
    <BNavbar  class="Waspl-bar">
        <BNavbarBrand class="navbar-brand-custom" href="#">
            <div class="logoSlog">
                <img class="logo-img" src="../assets/WASPLlogo150.png" alt="WASPL Logo">
                <span class="slog">The easy way</span>
            </div>
        </BNavbarBrand>

        <!-- Test Agenda button with dropdown centered -->
        <div class="navbar-nav mx-auto">
            <div class="dropdown">
                <button
                    class="btn btn-outline-light dropdown-toggle test-agenda-btn"
                    type="button"
                    id="testAgendaDropdown"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    @click="toggleAgendaDropdown"
                >
                    <i class="bi bi-calendar-event me-2"></i>
                    <span class="agenda-text">Test Agenda</span>
                </button>
                <div
                    class="dropdown-menu agenda-dropdown-menu"
                    aria-labelledby="testAgendaDropdown"
                    :class="{ 'show': agendaDropdownOpen }"
                >
                    <div class="agenda-dropdown-content">
                        <PublicationAgenda />
                    </div>
                </div>
            </div>
        </div>

        <div class="WasplConnect">
            <div v-if="userStore.user" class="helloUser">
                <div class="user-info">
                    <span class="hello-label">Hello</span>
                    <span class="user-name">{{ userStore.user.firstname }} {{ userStore.user.lastname }}</span>
                    <span class="user-divider">-</span>
                    <span class="username">{{ userStore.user.username }}</span>
                </div>
                <div class="dropdown text-start waspluser">
                    <a href="#" class="d-block link-light text-decoration-none dropdown-toggle user-menu-toggle"
                       id="dropdownUser1"
                       data-bs-toggle="dropdown"
                       aria-expanded="false">
                        <div class="user-avatar">
                            <font-awesome-icon :icon="['fas', 'circle-user']" class="topBarIcon" />
                        </div>
                    </a>
                    <ul class="dropdown-menu dropdown-menu-end user-dropdown" aria-labelledby="dropdownUser1">
                        <li class="dropdown-header">
                            <i class="bi bi-person-circle me-2"></i>Account
                        </li>
                        <li hidden><a class="dropdown-item" href="#"><i class="bi bi-gear me-2"></i>Settings</a></li>
                        <li><a class="dropdown-item" @click="profileModal.openModal" href="#">
                            <i class="bi bi-person me-2"></i>Profile
                        </a></li>
                        <li><hr class="dropdown-divider"></li>
                        <li><a @click="logout" class="dropdown-item text-danger" href="#">
                            <i class="bi bi-box-arrow-right me-2"></i>Sign out
                        </a></li>
                    </ul>
                </div>
            </div>
        </div>
    </BNavbar>
    <ProfileModal ref="profileModal" />
</template>


<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/stores/userStore';
import ProfileModal from '@/components/ProfileModal.vue';
import PublicationAgenda from '@/components/PublicationAgenda.vue';

const router = useRouter();
const userStore = useUserStore();
const profileModal = ref(null);
const agendaDropdownOpen = ref(false);

const toggleAgendaDropdown = () => {
    agendaDropdownOpen.value = !agendaDropdownOpen.value;
};

// Fermer le dropdown quand on clique à l'extérieur
const handleClickOutside = (event) => {
    const dropdown = document.getElementById('testAgendaDropdown');
    const dropdownMenu = dropdown?.nextElementSibling;
    
    if (dropdown && dropdownMenu && 
        !dropdown.contains(event.target) && 
        !dropdownMenu.contains(event.target)) {
        agendaDropdownOpen.value = false;
    }
};

onMounted(() => {
    document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside);
});

const logout = () => {
    userStore.logout();
    localStorage.removeItem('editortoken')
    router.push('/login')
}
</script>


<style scoped>
/* Navbar principale */
.Waspl-bar {
    padding-top: 25px;
    color: white;
    height: 100px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    background-color: rgb(76, 151, 212);
}

/* Logo et slogan */
.logoSlog {
    padding: 20px;
    margin-top: -20px;
    margin-left: 10px;
    transition: transform 0.2s ease;
}

.logoSlog:hover {
    transform: scale(1.02);
}

.logo-img {
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
    width:100px;
}

.slog {
    position: absolute;
    font-size: 0.8em;
    font-style: italic;
    margin-top: 27px;
    margin-left: 0px;
    opacity: 0.95;
    font-weight: 400;
    color:white
}

/* Bouton Test Agenda amélioré */
.test-agenda-btn {
    margin-top: 15px;
    border-color: rgba(255, 255, 255, 0.4);
    color: white;
    font-weight: 500;
    padding: 0.5rem 1.25rem;
    border-radius: 0.5rem;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.test-agenda-btn:hover {
    background-color: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.6);
    color: white;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.test-agenda-btn:active {
    transform: translateY(0);
}

.test-agenda-btn .bi {
    font-size: 1.1em;
    vertical-align: middle;
}

.agenda-text {
    vertical-align: middle;
}

/* User section */
.WasplConnect {
    inset: 0px auto auto 0px;
    margin-top: 25px;
    display: flex;
    align-items: center;
    gap: 1rem;
}

/* User greeting amélioré */
.helloUser {
    right: 20px;
    top: 20px;
    position: absolute;
    display: flex;
    align-items: center;
    gap: 1rem;
    font-size: 0.95rem;
    font-weight: 400;
    line-height: 1.5;
    background: rgba(255, 255, 255, 0.1);
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;
    backdrop-filter: blur(10px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.user-info {
    display: flex;
    align-items: center;
    text-align: right;
}

.hello-label {
    font-weight: 300;
    opacity: 0.9;
    margin-right: 0.3rem;
}

.user-name {
    font-weight: 600;
    margin-right: 0.5rem;
}

.user-divider {
    opacity: 0.5;
    margin: 0 0.5rem;
}

.username {
    font-weight: 400;
    opacity: 0.85;
    font-style: italic;
}

/* User menu */
.waspluser {
    position: relative;
    margin: 0;
}

.user-menu-toggle {
    transition: transform 0.2s ease;
}

.user-menu-toggle:hover {
    transform: scale(1.1);
}

.user-avatar {
    display: flex;
    align-items: center;
    justify-content: center;
}

.topBarIcon {
    color: white;
    font-size: 1.6em;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
    transition: all 0.3s ease;
}

.topBarIcon:hover {
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
    transform: scale(1.05);
}

/* User dropdown amélioré */
.user-dropdown {
    min-width: 220px;
    padding: 0.5rem 0;
    margin-top: 0.5rem;
    margin-left: 0;
    border: none;
    border-radius: 0.5rem;
    box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.2);
    animation: slideDown 0.2s ease;
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.user-dropdown .dropdown-header {
    padding: 0.75rem 1rem;
    font-weight: 600;
    color: #495057;
    border-bottom: 1px solid #e9ecef;
    margin-bottom: 0.25rem;
}

.user-dropdown .dropdown-header .bi {
    color: #0d6efd;
}

.user-dropdown .dropdown-item {
    padding: 0.6rem 1rem;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
}

.user-dropdown .dropdown-item .bi {
    font-size: 1.1em;
    width: 20px;
}

.user-dropdown .dropdown-item:hover {
    background-color: #f8f9fa;
    padding-left: 1.25rem;
}

.user-dropdown .dropdown-item.text-danger {
    color: #dc3545 !important;
}

.user-dropdown .dropdown-item.text-danger:hover {
    background-color: #fff5f5;
}

.user-dropdown .dropdown-divider {
    margin: 0.5rem 0;
    border-top-color: #e9ecef;
}

/* Dropdown générique */
.dropdown-menu {
    position: absolute;
    z-index: 1000;
    display: none;
    min-width: 10rem;
    padding: .5rem 0;
    font-size: 1rem;
    color: #212529;
    text-align: left;
    list-style: none;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, .15);
    border-radius: .25rem;
}

.dropdown-menu.show {
    display: block;
}

.dropdown-toggle::after {
    color: white;
}

/* Agenda dropdown */
.agenda-dropdown-menu {
    min-width: 600px;
    max-width: 800px;
    max-height: 70vh;
    overflow-y: auto;
    padding: 0;
    margin-top: 5px;
    box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.2);
    border: none;
    border-radius: 0.5rem;
}

.agenda-dropdown-content {
    padding: 1rem;
}

.agenda-dropdown-content .dashbordBlock {
    margin-bottom: 1rem;
}

.agenda-dropdown-content .AgendaBigTitle {
    font-size: 1rem;
    font-weight: 600;
    color: #495057;
}

.agenda-dropdown-content .evaluation-agenda {
    max-height: 400px;
    overflow-y: auto;
}

.agenda-dropdown-content .agenda-list {
    margin: 0;
    padding: 0;
}

.agenda-dropdown-content .agenda-item {
    padding: 0.5rem;
    margin-bottom: 0.25rem;
    border-radius: 0.25rem;
    transition: background-color 0.2s;
}

.agenda-dropdown-content .agenda-item:hover {
    background-color: #f8f9fa;
}

/* Utilities */
.text-small {
    font-size: 85%;
}

.shadow {
    box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .helloUser {
        display: none;
    }

    .test-agenda-btn .agenda-text {
        display: none;
    }

    .agenda-dropdown-menu {
        min-width: 90vw;
        max-width: 90vw;
    }
}
</style>